<template>
  <v-card>
    <v-card-text>
      <v-row dense>
        <v-col cols="12" sm="8">
          <p class="mb-1">
            <v-chip label class="mb-2" v-if="!isPainel">{{ solicitacao.id }}</v-chip>
            <span class="headline text--primary">
                {{ solicitacao.cotacaoFrete.company.pessoa.nome }}
              </span>
            <px-situacao-cotacao-frete-tag :situacao="solicitacao.cotacaoFrete.situacao"/>
          </p>
        </v-col>
        <v-col cols="12" sm="4"
               class="text-right"
               v-if="isNaoRespondida && isCotacaoAberta">
          <px-recusar-cotacao
            v-if="!isPainel"
            :loading="loadingRecusar"
            @change="onRecusar"/>
          <v-btn color="primary"
                 class="ml-2"
                 link
                 :to="linkToResposta">
            Responder
          </v-btn>
        </v-col>
        <v-col cols="12" sm="4"
               class="text-right"
               v-if="isRespondida">
          <v-btn color="primary"
                 class="ml-2"
                 link
                 :to="`/cotacoes/${solicitacao.id}/minha-resposta/${solicitacao.respostaFrete.id}`">
            Ver minha resposta
          </v-btn>
        </v-col>
        <v-col cols="12" sm="4"
               class="text-right"
               v-if="isRecusada">
          <px-situacao-solicitacao-frete-chip
            :situacao="solicitacao.situacao"/>
        </v-col>
      </v-row>
      <p class="mt-2">
        <v-icon>mdi-domain</v-icon>
        {{ solicitacao.cotacaoFrete.company.pessoa.cnpj | cnpj }}
      </p>
      <p>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon>mdi-map-marker</v-icon>
              {{ solicitacao.cotacaoFrete.company.endereco | endereco }}
            </span>
          </template>
          <span>Endereço da empresa cotadora</span>
        </v-tooltip>
      </p>
      <div class="text--primary">
        <v-row class="mb-3">
          <v-col cols="12" sm="3" v-if="solicitacao.cotacaoFrete.cpfCnpjColeta">
            <span class="caption font-weight-bold">CPF/CNPJ de coleta</span>
            <div>
              {{ solicitacao.cotacaoFrete.cpfCnpjColeta | cpfCnpj }}
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="solicitacao.cotacaoFrete.cpfCnpjEntrega">
            <span class="caption font-weight-bold">CPF/CNPJ de entrega</span>
            <div>
              {{ solicitacao.cotacaoFrete.cpfCnpjEntrega | cpfCnpj }}
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="solicitacao.cotacaoFrete.localPagamento">
            <span class="caption font-weight-bold">Pagador</span>
            <div>
              {{ localPagamento }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <span class="caption font-weight-bold">Coleta</span>
            <div>
              {{ solicitacao.cotacaoFrete.cepColeta | cep }}
              ({{ solicitacao.cotacaoFrete.municipioColeta.nome }} -
              {{ solicitacao.cotacaoFrete.municipioColeta.estado.sigla }})
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="caption font-weight-bold">Entrega</span>
            <div>
              {{ solicitacao.cotacaoFrete.cepEntrega | cep }}
              ({{ solicitacao.cotacaoFrete.municipioEntrega.nome }} -
              {{ solicitacao.cotacaoFrete.municipioEntrega.estado.sigla }})
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="3" v-if="solicitacao.cotacaoFrete.pesoTotal">
            <span class="caption font-weight-bold">Peso total (kg)</span>
            <div>
              {{ solicitacao.cotacaoFrete.pesoTotal }} kg
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Valor da mercadoria</span>
            <div>
              {{ solicitacao.cotacaoFrete.valorMercadoria | currency }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Quantidade de notas fiscais</span>
            <div>
              {{ solicitacao.cotacaoFrete.quantidadeNotas }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Tipo de mercadoria</span>
            <div>
              {{ solicitacao.cotacaoFrete.tipoMercadoria }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="9">
            <span class="caption font-weight-bold">Observação</span>
            <div>
              {{ solicitacao.cotacaoFrete.observacao | naoInformado }}
            </div>
          </v-col>
          <v-col cols="3" v-if="solicitacao.outroMotivo">
            <span class="caption font-weight-bold">Motivo de recusa</span>
            <div>
              {{ solicitacao.outroMotivo }}
            </div>
          </v-col>
        </v-row>
      </div>
      <v-row>
        <v-col cols="12">
          <v-card outlined>
            <v-subheader>
              <v-icon class="mr-2">mdi-package-variant</v-icon>
              Volumes
            </v-subheader>
            <v-divider/>
            <div class="body-1 mt-3" align="center"
            v-if="!solicitacao.cotacaoFrete.volumes || !solicitacao.cotacaoFrete.volumes.length">
              Não há volumes nessa cotação
            </div>
            <px-cotacao-detalhes-volumes :cotacao="solicitacao.cotacaoFrete"/>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { SituacaoCotacao, SituacaoSolicitacaoFrete, LocalPagamentoFrete } from 'px-business-components';
import CotacaoDetalhesVolumes from './CotacaoDetalhesVolumes.vue';
import RecusarCotacao from '../recusar/RecusarCotacao.vue';
import CotacaoService from '../cotacoes-service';

const NAO_RECUSADAS = [SituacaoSolicitacaoFrete.keys.NAO_RESPONDIDA.key,
  SituacaoSolicitacaoFrete.keys.RESPONDIDA.key,
  SituacaoSolicitacaoFrete.keys.CANCELADA.key];

const ABERTAS = [SituacaoCotacao.keys.ABERTA.key,
  SituacaoCotacao.keys.CARRINHO.key,
  SituacaoCotacao.keys.COMPRA.key];

export default {
  props: {
    solicitacao: Object,
    isPainel: Boolean,
  },
  data() {
    return {
      loadingRecusar: false,
    };
  },
  computed: {
    isNaoRespondida() {
      return this.solicitacao.situacao
        === SituacaoSolicitacaoFrete.keys.NAO_RESPONDIDA.key;
    },
    isCotacaoAberta() {
      return ABERTAS.includes(this.solicitacao.cotacaoFrete.situacao);
    },
    isRespondida() {
      return this.solicitacao.situacao
        === SituacaoSolicitacaoFrete.keys.RESPONDIDA.key;
    },
    isRecusada() {
      return !NAO_RECUSADAS.includes(this.solicitacao.situacao);
    },
    linkToResposta() {
      if (this.isPainel) {
        return `/cotacoes/${this.solicitacao.cotacaoFrete.id}/responder?origin=PAINEL`;
      }
      return `/cotacoes/${this.solicitacao.id}/responder`;
    },
    localPagamento() {
      return LocalPagamentoFrete.keys[this.solicitacao.cotacaoFrete.localPagamento].description;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    onRecusar(option) {
      this.loadingRecusar = true;
      CotacaoService.recusar(this.solicitacao.id, {
        situacao: option.key,
        outroMotivo: option.motivo,
      })
        .then(() => {
          this.emitUpdate();
          this.$toast('Solicitação recusada', { color: 'success' });
        })
        .finally(() => {
          this.loadingRecusar = false;
        });
    },
  },
  components: {
    pxCotacaoDetalhesVolumes: CotacaoDetalhesVolumes,
    pxRecusarCotacao: RecusarCotacao,
  },
};
</script>
